import type { UserList, UserRow } from '@app/application/user-management/types'

import { defineStore } from 'pinia'
import { ref } from 'vue'

import { fetchUsers } from '@app/application/user-management/api'
import { SfLog } from '@app/adapters/logger'

export const useUsersStore = defineStore('users', () => {
  const users = ref<UserRow[]>([])
  const loading = ref(true)
  const error = ref(false)

  const loadUsers = async (list: UserList): Promise<void> => {
    loading.value = true
    error.value = false

    try {
      const response = await fetchUsers({ list })

      users.value = response?.users ?? []
    } catch (e) {
      error.value = true
      SfLog.warn('Failed to load the users list', { extra: { error: e } })
    } finally {
      loading.value = false
    }
  }

  return {
    users,
    loading,
    error,
    loadUsers,
  }
})
